export const GIT_SHA = `${import.meta.env.VITE_GIT_SHA}` || 'DEVELOPMENT';
export const GIT_SHA_SHORT = GIT_SHA.slice(0, 6);
const ENV_str =
  `${import.meta.env.VITE_ENV || import.meta.env.MODE}` || 'local';

export enum Environment {
  'beta' = 'beta',
  'test' = 'test',
  'local' = 'local',
  'development' = 'development',
  'staging' = 'staging',
  'production' = 'production',
}

function isENV(ENV_str: string): ENV_str is Environment {
  return [
    'beta',
    'test',
    'local',
    'development',
    'staging',
    'production',
  ].includes(ENV_str);
}
if (!isENV(ENV_str)) {
  throw new Error(`INVALID REACT_APP_ENV value: ${ENV_str}`);
}
export const ENV: Environment = ENV_str;

export const currentEnvUsesProductionBackend = ['production', 'beta'].includes(
  ENV
);

export const isTestEnv = [
  Environment.test,
  Environment.development, // "development" env (aka ml-development.motional.com) is used for load testing
].includes(ENV);

export const isStagingEnv = [Environment.staging, Environment.local].includes(
  ENV
);

export const isProductionEnv = [
  Environment.production,
  Environment.beta,
].includes(ENV);
